import React from "react";
import PropTypes from 'prop-types';
import Form from "./Form";
import logo from 'assets/images/im_logo2.png';
import logo2 from 'assets/images/logo2.svg';
import { Trans } from 'components';

const propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.shape({
    url: PropTypes.oneOf(['/password/confirm/:uid/:token'])
  }).isRequired,
};

class PasswordConfirm extends React.Component {

  render() {
    const {match} = this.props;
    const {uid, token} = match.params;

    return (
      <div className="body login-page-wrapper">
        <div className="image-container">
          <div className="im-logo-container">
            <img src={logo} alt="" />
          </div>
        </div>
        <div className="form-container">
          <div className="form-container-inner">
            <div className="form-heading">
              
              <h3><Trans>Zmień hasło</Trans></h3>
              <h5>innovative thinking, global perspective</h5>
            </div>
            <Form uid={uid} token={token} />
          </div>
          <div className="copyrights">
            <a href="https://kivy.pl">
              <span className="copyrights-text">Created by</span><span className="kivy-logo"><img src={logo2} alt="" /></span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

PasswordConfirm.propTypes = propTypes;
export default PasswordConfirm;


// WEBPACK FOOTER //
// ./src/pages/password/confirm/Confirm.jsx